import { getAccess, clearTokens } from "./auth";
import { API_BASE } from "./config";
import { refreshSession } from "./refreshSession";

// Wrapper with auto-refresh + retry-once
export async function apiRequest(path, options = {}, retry = true) {
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  const headers = {
    ...(!isFormData && options.body ? { "Content-Type": "application/json" } : {}),
    ...(options.headers || {}),
  };

  const access = getAccess();
  if (access && headers.Authorization == null) {
    headers.Authorization = `Bearer ${access}`;
  }

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  // If unauthorized, try refresh once
  if (res.status === 401 && retry) {
    try {
      const body = await res.clone().json().catch(() => ({}));
      const isExpired =
        body?.code === "token_not_valid" ||
        (Array.isArray(body?.messages) && body.messages.some(m => m?.message?.toLowerCase().includes("expired")));

      if (isExpired) {
        const currentAccess = getAccess();
        const newAccess = currentAccess && currentAccess !== access
          ? currentAccess : (await refreshSession()).access;
        if (newAccess) {
          const retryHeaders = { ...headers, Authorization: `Bearer ${newAccess}` };
          return fetch(`${API_BASE}${path}`, { ...options, headers: retryHeaders });
        }
      }
    } catch (error) {
      if (error.code === "session_changed") return res;
      // ignore parse errors; fall through to logout
    }
    clearTokens();
    window.location.href = "/login";
    return res; // unreachable post-redirect, but keeps types happy
  }

  return res;
}
